module.exports = __webpack_public_path__ + "static/media/emerald_diamond.a1fc3f59.png";